require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-ahrefs-bs-aws-lambda.json") })
        }
      }, "path---package-ahrefs-bs-aws-lambda");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-ahrefs-bs-aws-lambda!./.cache/json/package-ahrefs-bs-aws-lambda.json
// module id = 742
// module chunks = 231608221292675